// import Mytodo from "./components/todoreact/Mytodo";

import PracticeTodos from "./components/todoreact/PracticeTodos";

function App() {
  return (
    <div className="App">
      {/* <Mytodo /> */}
      <PracticeTodos />
    </div>
  );
}

export default App;
